import { Navigate, useLocation } from "react-router-dom";
import { AREAS } from "@/data/areas";

// Old Wix site URLs -> closest page on the new site.
const EXACT = {
  "/about": "/#why",
  "/work": "/",
  "/bathrooms": "/services/custom-shower-screens-sydney",
  "/additions": "/services/frameless-glass-balustrades-sydney",
  "/services-4": "/services/stainless-steel-fabrication-sydney",
  "/services/emergency-glass-replacement": "/services/glass-replacement-sydney",
  "/services/glass-replacement": "/services/glass-replacement-sydney",
  "/services/frameless-glass-balustrades": "/services/frameless-glass-balustrades-sydney",
  "/services/glass-pool-fencing": "/services/glass-pool-fencing-sydney",
  "/services/shower-screens": "/services/custom-shower-screens-sydney",
  "/services/mirrors": "/services/custom-mirror-installation-sydney",
  "/services/splashbacks": "/services/mirror-splashbacks-sydney",
  "/services/stainless-steel": "/services/stainless-steel-fabrication-sydney",
};

const areaForSuburb = (suburb) => {
  const s = suburb.replace(/-/g, " ").toLowerCase();
  return AREAS.find((a) => a.matchSuburbs.some((x) => x.toLowerCase() === s));
};

export const resolveLegacyPath = (pathname) => {
  const path = pathname.replace(/\/+$/, "").toLowerCase() || "/";
  if (EXACT[path]) return EXACT[path];
  const repair = path.match(/^\/glass-(?:repair|replacement)-([a-z0-9-]+)$/);
  if (repair) {
    const area = areaForSuburb(repair[1]);
    return area ? `/areas/${area.slug}` : "/services/glass-replacement-sydney";
  }
  if (/^\/services-\d+$/.test(path)) return "/#services";
  if (/^\/(blog|post|gallery|projects|portfolio)(\/|$)/.test(path)) return "/";
  return "/";
};

export default function LegacyRedirect() {
  const { pathname } = useLocation();
  return <Navigate to={resolveLegacyPath(pathname)} replace />;
}
